<template>
  <div class="jsc-bg">
    <div class="imgbg"></div>
    <!-- 顶部 -->
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">学业预警数据</div>
      <div class="sys-temp"><div id="he-plugin-simple"></div></div>
    </div>
    <div class="center" v-if="showOne && showTwo && showCenter && showThree && showFour">
      <div class="center-left">
        <div class="left-top" v-if="showOne">
          <academic-one :failRateData="failRateData"></academic-one>
        </div>
        <div class="left-bottom" v-if="showTwo">
          <academic-two></academic-two>
        </div>
      </div>
      <div class="center-center" v-if="showCenter">
        <academic-center
          :percent="percent"
          :warningNum="warningNum"
          :classWarningData="classWarningData"
        ></academic-center>
      </div>
      <div class="center-right">
        <div class="right-top" v-if="showThree">
          <academic-three :focusStudents="focusStudents"></academic-three>
        </div>
        <div class="right-bottom" v-if="showFour">
          <academic-four :gradeWarningData="gradeWarningData"></academic-four>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCollegeSportFailRate,
  getCollegeGradeWarn,
  getFocusOnStudents,
  getWarningNumber,
  getCourseWarningNumber,
  getGradeWarningNumber,
} from '@/api/api-learnCockpit'
import AcademicOne from './components/AcademicOne.vue'
import AcademicTwo from './components/AcademicTwo.vue'
import AcademicThree from './components/AcademicThree.vue'
import AcademicFour from './components/AcademicFour.vue'
import AcademicCenter from './components/AcademicCenter.vue'
export default {
  name: '',
  components: {
    AcademicOne,
    AcademicTwo,
    AcademicThree,
    AcademicFour,
    AcademicCenter,
  },
  directives: {},
  data() {
    return {
      today: '',
      timer: null,
      showOne: false,
      showTwo: false,
      showCenter: false,
      showThree: false,
      showFour: false,
      percent: 50,
      failRateData: {}, //挂科率
      gradeWarningData: [], //各年级预警人数
      focusStudents: [], //重点关注学生
      classWarningData: [], //各课程预警数据
      warningNum: {}, //预警人数
    }
  },
  created() {
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 10 ? date.month : '0' + date.month
    let newday = date.date > 10 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday
    //数据请求
    this.collegeSportFailRate()
    this.collegeGradeWarn()
    this.focusOnStudents()
    this.warningNumber()
    this.courseWarningNumber()
    this.gradeWarningNumber()
    this.timer = setInterval(() => {
      this.collegeSportFailRate()
      this.collegeGradeWarn()
      this.focusOnStudents()
      this.warningNumber()
      this.courseWarningNumber()
      this.gradeWarningNumber()
    }, 60000)
  },
  mounted() {
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    collegeSportFailRate() {
      getCollegeSportFailRate().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('挂科率分析:', res)
          this.failRateData = res.data.obj
          this.showOne = true
        }
      })
    },
    collegeGradeWarn() {
      getCollegeGradeWarn().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('学院课程成绩预警数据:', res)
          this.showTwo = true
        }
      })
    },
    focusOnStudents() {
      getFocusOnStudents().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('获取重点关注学生:', res)
          this.focusStudents = res.data.obj
          this.showThree = true
        }
      })
    },
    warningNumber() {
      getWarningNumber().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('获取预警人数:', res)
          this.warningNum = res.data.obj
          this.showCenter = true
        }
      })
    },
    courseWarningNumber() {
      getCourseWarningNumber().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('获取各课程预警人数:', res)
          this.classWarningData = res.data.obj
        }
      })
    },
    gradeWarningNumber() {
      getGradeWarningNumber().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('获取各年级预警人数:', res)
          this.gradeWarningData = res.data.obj
          this.showFour = true
        }
      })
    },
  },
  destroyed() {
    clearInterval(this.timer)
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
.top {
  background: url('../../assets/img/cockpit/top.svg') no-repeat;
}
.imgbg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: url('../../assets/img/academic/mbg.svg') no-repeat;
  background-size: 100%;
}
.left-top {
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
}
.left-bottom {
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
}
.right-top {
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
}
.right-bottom {
  margin-top: 16px;

  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
}
.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}
.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}
</style>
